import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LayoutType } from "../../../core/configs/config";
import { LayoutService } from "../../../core/layout.service";

@Component({
    selector: "app-sidebar-logo",
    templateUrl: "./sidebar-logo.component.html",
    styleUrls: ["./sidebar-logo.component.scss"],
    standalone: false
})
export class SidebarLogoComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];
  @Input() toggleButtonClass: string = "";
  @Input() toggleEnabled: boolean;
  @Input() toggleType: string = "";
  @Input() toggleState: string = "";

  @Output() toggleChange = new EventEmitter();

  currentLayoutType: LayoutType | null;

  toggleAttr: string;
  isToggle: boolean = false;

  constructor(private layout: LayoutService) {}

  ngOnInit(): void {
    this.toggleAttr = `app-sidebar-${this.toggleType}`;
    const layoutSubscr = this.layout.currentLayoutTypeSubject
      .asObservable()
      .subscribe((layout) => {
        this.currentLayoutType = layout;
      });
    this.unsubscribe.push(layoutSubscr);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  toggleClick() {
    this.isToggle = !this.isToggle;
    this.toggleChange.emit(this.isToggle);
  }
}
